import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=6e7004fe&scoped=true&"
import script from "./AppMain.vue?vue&type=script&lang=ts&"
export * from "./AppMain.vue?vue&type=script&lang=ts&"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=6e7004fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7004fe",
  null
  
)

export default component.exports